<template>
  <div class="media-uploader">
    <h1 class="media-uploader__title">Добавить</h1>
    <div class="media-uploader__loader">
      <FileUpload
        mode="advanced"
        name="file"
        :url="`${envUrlBase}/api/EduCompanyInfo/PutInfoBlockFileToCache/14`" @before-send="authToken" :auto="false"
        fileLimit="1"
        previewWidth="0"
        @select="onSelectedFiles"
      >
        <template #header="{ chooseCallback, uploadCallback, files, uploadedFiles }">
          <BaseBtn
            blue
            text="Загрузить"
            v-if="files.length > 0"
            @click="uploadCallback()"
            :disabled="!files || files.length > 1"
            rounded
            outlined
          />
          <BaseBtn
            blue
            text="Выбрать"
            @click="chooseCallback()"
            :disabled="(!files || files.length > 0) || (!files || uploadedFiles.length > 0)"
          />
        </template>
        <template #empty>
          <div class="flex align-items-center justify-content-center flex-column">
            <UploaderMediaIcon />
            <p
              class="mt-4 mb-0"
              style="font-size: 20px;
              margin-bottom: 12px;
              line-height: 24px;"
            >
              Перетащите файл сюда <br>или</p>
          </div>
        </template>
      </FileUpload>
    </div>
  </div>
</template>

<script>
import { useStore } from 'vuex'

import UploaderMediaIcon from '@/components/icons/UploaderMediaIcon.vue'
import BaseBtn from '@/components/ui/BaseBtn.vue'
import FileUpload from 'primevue/fileupload'

export default {
  name: 'MediaUploader',
  components: {
    FileUpload,
    UploaderMediaIcon,
    BaseBtn
  },
  props: {
  },
  setup () {
    const store = useStore()

    const envUrlBase = process.env.VUE_APP_URL_EDUCATION

    const authToken = (e) => {
      e.xhr.setRequestHeader('Authorization', `Bearer ${localStorage.token || sessionStorage.token}`)
    }

    // получаем объект выбранного файла из события выбора файла для загрузки для того, чтобы взять оттуда имя файла и вывести его в компоненте страницы "структура и органы управления" ДО ТОГО как отправили измененные данные на бек и получили их обратно
    const onSelectedFiles = (e) => {
      e.files.forEach((item) => {
        store.commit('SetUploadFileName', item.name)
      })
    }

    return {
      envUrlBase,
      authToken,
      onSelectedFiles
    }
  }
}
</script>

<style lang="scss" scoped>
.media-uploader {

  &__title {
    display: flex;
    margin-bottom: 24px;
    font-size: 20px;
  }

  &__loader {
    display: flex;
    justify-content: center;
    width: 1150px;
    height: 322px;
    margin-bottom: 32px;
    background: #FCFCFC;
    border: 2px solid #DCDCDC;

    :deep(.p-fileupload) {
      display: flex;
      flex-direction: column;
      margin: 56px 0px;
      width: 100%;
    }

    :deep(.p-fileupload-content) {
      width: 100%;
      margin-bottom: 10px;
      background-color: #FCFCFC;
    }

    :deep(.p-fileupload-file) {
      justify-content: center;
    }

    :deep(.p-fileupload-buttonbar) {
      justify-content: center;
      order: 1;
      background: #FCFCFC;
    }

    :deep(.p-fileupload-empty) {
      background: #FCFCFC;
    }

    :deep(.p-progressbar) {
      display: none;
    }

    :deep(.p-button) {
      background: #FCFCFC;
    }

    :deep(.p-message-close) {
      background: #FFCDD2;
    }

    :deep(.p-fileupload-file-size) {
      margin-right: 10px;
    }

    :deep(svg) {
      margin-bottom: 20px;
    }
  }

  &__button {
    display: flex;
    justify-content: flex-end;
  }
}
</style>
